import { useState, type FormEvent } from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'
import { fieldErrors, isApiError, errorMessage } from '../lib/api'
import { safeNext, useLogin, useSession } from '../lib/auth'
import { AuthShell } from '../components/AuthShell'
import { Button, Field, Input } from '../components/ui'

export function Login() {
  const [params] = useSearchParams()
  const next = safeNext(params.get('next'))
  const session = useSession()
  const login = useLogin()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  // Already signed in (or just signed in): go where they were heading.
  if (session.data) return <Navigate to={next} replace />

  const errs = fieldErrors(login.error)
  const formError =
    login.error && Object.keys(errs).length === 0
      ? isApiError(login.error, 401)
        ? 'That email and password don’t match.'
        : errorMessage(login.error)
      : null

  const submit = (e: FormEvent) => {
    e.preventDefault()
    login.mutate({ email: email.trim(), password })
  }

  return (
    <AuthShell
      title="Sign in"
      footer="ShipDesk is invite-only. Ask your admin for an invitation if you don’t have an account."
    >
      <form onSubmit={submit} className="space-y-4" noValidate>
        <Field label="Email" error={errs.email}>
          <Input
            type="email"
            autoComplete="email"
            autoFocus
            required
            value={email}
            invalid={!!errs.email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Field>
        <Field label="Password" error={errs.password}>
          <Input
            type="password"
            autoComplete="current-password"
            required
            value={password}
            invalid={!!errs.password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Field>
        {formError && (
          <p role="alert" className="text-sm text-critical-fg">
            {formError}
          </p>
        )}
        <Button type="submit" variant="primary" className="w-full" disabled={login.isPending || !email || !password}>
          {login.isPending ? 'Signing in…' : 'Sign in'}
        </Button>
      </form>
    </AuthShell>
  )
}
